import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SwiperCore from 'swiper';

import { Nullish } from '@tager/web-core';
import { useModal } from '@tager/web-components';

import { Props } from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import SliderModal from '@/components/DetailedCarGallery/components/SliderModal';
import BigSlider from '@/components/DetailedCarGallery/components/BigSlider';
import BottomSlider from '@/components/DetailedCarGallery/components/BottomSlider';
import { StyledOverlay } from '@/components/modals/shared/StyledOverlay';

function DetailedCarGallery({
  images,
  layout,
  alt,
  subneilsPerView = 5,
}: Props) {
  const [thumbsSwiper, setThumbsSwiper] = useState<Nullish<SwiperCore>>(null);
  const [swiper, setSwiper] = useState<SwiperCore | null>(null);
  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(1);
  const isMobile = layout === 'mobile';
  const openModal = useModal();

  const handleOpenModal = () => {
    setModalOpened(true);
    openModal(
      SliderModal,
      {
        images,
        currentSlideIndex,
        setCurrentSlideIndex,
        isMobile,
        subneilsPerView,
        onClose: () => setModalOpened(false),
      },
      { components: { Overlay: StyledOverlay }, scrollLockDisabled: true }
    );
  };
  useEffect(() => {
    if (swiper && modalOpened) {
      swiper?.slideTo(currentSlideIndex);
      if (!isMobile) {
        thumbsSwiper?.slideTo(currentSlideIndex);
      }
    }
  }, [currentSlideIndex, isMobile, modalOpened, swiper, thumbsSwiper]);

  return (
    <Component>
      <BigSlider
        onClick={() => handleOpenModal()}
        images={images}
        currentSlideIndex={currentSlideIndex}
        setCurrentSlideIndex={setCurrentSlideIndex}
        thumbsSwiper={thumbsSwiper}
        alt={alt}
        isMobile={isMobile}
        subneilsPerView={subneilsPerView}
        setSwiper={setSwiper}
      />

      {images.length > 1 && subneilsPerView > 1 && !isMobile && (
        <BottomSlider
          images={images}
          setSlider={setThumbsSwiper}
          subneilsPerView={subneilsPerView}
          currentSlideIndex={currentSlideIndex}
        />
      )}
    </Component>
  );
}
const Component = styled.div``;

export default DetailedCarGallery;
